/**
 * Applies a resolution action to a suggestion.
 *
 * Terminal suggestions (`accepted`, `rejected`, or `superseded`) are returned
 * unchanged, so reapplying an action is safe and idempotent.
 *
 * @param suggestion - Suggestion to resolve.
 * @param action - Human resolution to apply.
 * @returns The transitioned suggestion, or the original terminal suggestion.
 */
export function applySuggestionAction(suggestion, action) {
    if (suggestion.status !== 'pending')
        return suggestion;
    if (action.type === 'accept')
        return { ...suggestion, status: 'accepted' };
    return { ...suggestion, status: 'rejected', feedback: action.feedback };
}
/**
 * Builds a model-facing summary of accepted/rejected suggestions.
 *
 * @param suggestions - Suggestion history to summarize.
 * @returns Newline-separated resolved feedback, or an empty string.
 */
export function summariseFeedback(suggestions) {
    const resolved = suggestions.filter((s) => s.status === 'accepted' || s.status === 'rejected');
    if (resolved.length === 0)
        return '';
    return resolved
        .map((s) => {
        const verdict = s.status === 'accepted' ? 'accepted' : 'rejected';
        const note = s.feedback ? ` — feedback: ${s.feedback}` : '';
        return `[${verdict}] "${s.original}" → "${s.suggested}"${note}`;
    })
        .join('\n');
}
//# sourceMappingURL=suggestions-core.js.map